import { render, staticRenderFns } from "./excerpt.vue?vue&type=template&id=3016944a&scoped=true&"
import script from "./excerpt.vue?vue&type=script&lang=js&"
export * from "./excerpt.vue?vue&type=script&lang=js&"
import style0 from "./excerpt.vue?vue&type=style&index=0&id=3016944a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3016944a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3016944a', component.options)
    } else {
      api.reload('3016944a', component.options)
    }
    module.hot.accept("./excerpt.vue?vue&type=template&id=3016944a&scoped=true&", function () {
      api.rerender('3016944a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/excerpt.vue"
export default component.exports